import React from 'react';
import { HeaderFilterTable } from '@/components/common';
import { Options } from '@/components/ui/combobox';
import { useApplyFilterMultiple } from '@/hooks/filters/useApplyFilterMultiple';

interface Props {
	disabled?: boolean;
}

export const DocumentStatus: React.FC<Props> = ({ disabled }) => {
	const { selected, hasFilter, handleClearAll, handleSelectFilters } =
		useApplyFilterMultiple({ filterKey: 'document_status' });

	const data: Options[] = [
		{
			label: 'Received',
			value: 'Received',
		},
		{
			label: 'Pending',
			value: 'Pending',
		},
	];

	return (
		<HeaderFilterTable
			title="Document Status"
			searchTitle="Document Status"
			type="multiple"
			values={selected}
			filterOptions={data}
			handleClearAll={handleClearAll}
			handleSelectFilters={handleSelectFilters}
			hasFilter={hasFilter('document_status')}
			classNamePopoverContent="lg:w-[302px]"
			buttonContentDefault={false}
			disabled={disabled}
		/>
	);
};
